<mat-card style="margin-top:30px">
  <mat-card style="width:300px;margin:auto">
   <mat-card-title align="center">Sistema de Gestió (ERP)</mat-card-title>
   <mat-card-subtitle align="center">{{ 'login.subtitol' | translate }}</mat-card-subtitle>
   <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
    <mat-card-content>
      <mat-form-field>
        <mat-label>{{ 'login.correuLabel' | translate }}</mat-label>
        <input matInput [(ngModel)]="userData.email" name="email"
          placeholder="{{ 'login.correuPlaceholder' | translate }}" style="width: 100%" type="email"
          required ngDefaultControl />
      </mat-form-field><br>
      <mat-form-field>
        <mat-label>{{ 'login.contrasenyaLabel' | translate }}</mat-label>
        <input matInput [(ngModel)]="userData.password" name="password" placeholder="{{ 'usuaris.dialeg.clau' | translate }}"
          style="width: 100%" type="password" required ngDefaultControl />
      </mat-form-field>
     </mat-card-content>
     <mat-card-actions style="margin:auto;margin-bottom: 1em;">
        <button mat-raised-button color="secondary" type="submit">{{ 'login.iniciarSessio' | translate }}</button>
     </mat-card-actions>
    </form>
  </mat-card>

  <div *ngIf="lastError" class="error">
    <mat-card-title align="center">{{ 'login.errorTitol' | translate }}</mat-card-title>
    <mat-card-content align="center">
      <p>{{lastError.message}}</p>
    </mat-card-content>
  </div>

  <div style="clear:both;width:150px;padding-top:20px;margin:auto"><img src="./assets/LogoV.png" style="width:100%;height:100%"></div>
</mat-card>

 <mat-card *ngIf="lastError" class="error">
  <mat-card-title align="center">{{lastError.status}}</mat-card-title>
  <mat-card-subtitle align="center">{{lastError.statusText}}</mat-card-subtitle>
  <mat-card-content align="center">
    <p>{{lastError.message}}</p>
  </mat-card-content>
</mat-card>
